import { LinkExpirationSetting } from 'modules/domains/links';
import { FieldNamesMarkedBoolean } from 'react-hook-form';
import { LINK_ACTIONS } from './constants';
import { LinksFieldArray } from './types';

/** Utility function to format redirect location */
export const getRedirectLocation = ({ redirectLocation, linkAction }: LinkExpirationSetting) =>
  linkAction === LINK_ACTIONS.customRedirect ? redirectLocation : '';

export const createUpdateAllPayload = (
  values: LinkExpirationSetting[],
  setting: LinkExpirationSetting,
) => {
  return {
    linkExpirationSettings: values.map((value) => ({
      ...value,
      linkAction: setting.linkAction,
      effectiveDate: setting.effectiveDate,
      redirectLocation: getRedirectLocation(setting),
    })),
  };
};

export const createDirtyLinksPayload = (
  values: LinkExpirationSetting[],
  dirtyFields: FieldNamesMarkedBoolean<LinksFieldArray>,
) => {
  const dirtyFieldKeys = Object.keys(dirtyFields?.links ?? {});
  return {
    linkExpirationSettings: dirtyFieldKeys.map((key: string) => {
      const setting = values[Number(key)];
      const redirectLocation = getRedirectLocation(setting);
      return {
        ...setting,
        redirectLocation,
      };
    }),
  };
};
